import { Upload } from "lucide-react";

interface UploadBoxProps {
  isDragging: boolean;
  onDragEnter: (e: React.DragEvent) => void;
  onDragLeave: (e: React.DragEvent) => void;
  onDragOver: (e: React.DragEvent) => void;
  onDrop: (e: React.DragEvent) => void;
}

export const UploadBox = ({
  isDragging,
  onDragEnter,
  onDragLeave,
  onDragOver,
  onDrop,
}: UploadBoxProps) => {
  return (
    <div
      onDragEnter={onDragEnter}
      onDragLeave={onDragLeave}
      onDragOver={onDragOver}
      onDrop={onDrop}
      className={`
        border-2 border-dashed rounded-lg p-8
        transition-all duration-200 ease-in-out
        flex flex-col items-center justify-center
        bg-purple-50 hover:bg-purple-100
        ${isDragging ? "border-primary bg-purple-100" : "border-purple-300"}
      `}
    >
      <Upload className="w-10 h-10 text-purple-500 mb-4" />
      <input
        type="file"
        multiple
        onChange={(e) => {
          const files = e.target.files ? Array.from(e.target.files) : [];
          const event = new CustomEvent('filesSelected', { detail: files });
          window.dispatchEvent(event);
        }}
        className="hidden"
        id="file-upload"
      />
      <label
        htmlFor="file-upload"
        className="cursor-pointer text-sm text-purple-700 hover:text-purple-900 transition-colors"
      >
        Click to upload or drag and drop
      </label>
    </div>
  );
};